import { CHEQUE_TRANSACTIONS } from '../actionTypes';

export const fetchChequeTransactions = (action) => ({
  type: CHEQUE_TRANSACTIONS.FETCH,
  payload: action.payload,
});
